import React, { useState } from "react";
import MetaTagsList from "./MetaTagsList";

const Dashboard = ({ logout }) => {
    const [activeTab, setActiveTab] = useState("Pdpl");
    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };


    const siteNameMap = {
        Pdpl: "plusdistributions.in",
        Glee: "glee.sakshi.xyz",
        Guffic: "guffic.sakshi.xyz",
        Plusgen: "plusgen.sakshi.xyz",
        Medcart: "medcart.sakshi.xyz",
        Unios: "unios.sakshi.xyz"
    };

    return (
        <>
            <div className="h-screen lg:overflow-hidden overflow-x-hidden">
                <div className='bg-[#75aebf]'>
                    <div className="max-w-[1440px] mx-auto px-4">
                        <div className="py-3 mb-10 flex justify-between items-center">
                            <h1 className="sm:text-4xl text-2xl font-semibold text-white text-center leading-normal">
                                Meta Tag Protal
                            </h1>
                            <button onClick={() => {
                                logout();
                            }} type="button" className="submit-btn bg-[#025066] hover:scale-95 sm:px-[40.5px] px-8 sm:py-4 transition-all duration-300 ease-linear rounded-md text-white text-[16px] font-semibold py-[14px]">

                                Logout
                            </button>
                        </div>
                    </div>
                </div>
                <div className="max-w-[1440px] mx-auto px-4">
                    <div
                        className="flex flex-wrap justify-between lg:gap-0 gap-6 lg:h-[600px] overflow-scroll"
                        data-aos="fade-up"
                    >
                        <div className="lg:w-100 overflow-scroll lg:h-[600px] mx-auto">
                            <MetaTagsList siteName={siteNameMap[activeTab]} />
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default Dashboard